import React from 'react';

/**
 * planZ — Z harfi ikonu
 * SVG tabanlı, arka plan şeffaf (tema rengini miras alır).
 * Gradient: turuncu-kırmızı → amber
 */
const PlanZIcon = ({ size = 32, style = {} }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block', flexShrink: 0, ...style }}
    >
        <defs>
            <linearGradient
                id="planZGrad"
                x1="15"
                y1="15"
                x2="85"
                y2="85"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#EF4444" />
                <stop offset="40%" stopColor="#F97316" />
                <stop offset="100%" stopColor="#FBBF24" />
            </linearGradient>
        </defs>

        {/* Z harfi — kalın yuvarlatılmış çizgi */}
        <polyline
            points="18,18 82,18 18,82 82,82"
            stroke="url(#planZGrad)"
            strokeWidth="18"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </svg>
);

export default PlanZIcon;
